import { render, staticRenderFns } from "./Wishlist.vue?vue&type=template&id=96c70ace&scoped=true"
import script from "./Wishlist.vue?vue&type=script&lang=js"
export * from "./Wishlist.vue?vue&type=script&lang=js"
import style0 from "./Wishlist.vue?vue&type=style&index=0&id=96c70ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c70ace",
  null
  
)

export default component.exports